import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {IonContent, ModalController, Platform} from '@ionic/angular';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Subscription} from 'rxjs';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {WstxcbService} from '../service/wstxcb.service';
import {AccountService} from '../service/account.service';
import {HelperService} from "../service/helper.service";
import {CustomNumberService} from "../service/custom-number.service";
import {HttpResponse} from "@angular/common/http";
import {ApiService} from "../service/api.service";
import {TranslateConfigService} from "../service/translate-config.service";
import {BxhXocDiaComponent} from "./bxh/bxh.component";
import {LscXocDiaComponent} from "./lsc/lsc.component";
import {LspXocDiaComponent} from "./lsp/lsp.component";
import {TkpXocDiaComponent} from "./tkp/tkp.component";
import {HdXocDiaComponent} from "./hd/hd.component";

@Component({
  selector: 'app-xocdia',
  templateUrl: './xocdia.component.html',
  styleUrls: ['./xocdia.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('displayBoxChat', [
      state('leave', style({
        opacity: '0',
        transform: 'scale(0.7)'
      })),
      state('show', style({
        opacity: '1',
        transform: 'scale(1)'
      })),
      state('hidden', style({
        display: 'none'
      })),
      transition('leave => show', animate('200ms cubic-bezier(0.36, 0.66, 0.04, 1.3)')),
      transition('show => leave', animate('700ms cubic-bezier(0.36, 0.66, 0.04, 1.6)'))
    ]),
    trigger('moneyBetting', [
      state('zoomIn', style({
        transform: 'scale(1.07)'
      })),
      state('zoomOut', style({
        transform: 'scale(1)'
      })),
      transition('zoomIn => zoomOut', animate('150ms ease-in-out')),
      transition('zoomOut => zoomIn', animate('150ms ease-in-out'))
    ]),
    trigger('timerCountdown', [
      state('zoomIn', style({
        transform: 'scale(1.07)'
      })),
      state('zoomOut', style({
        transform: 'scale(1)'
      })),
      transition('zoomIn => zoomOut', animate('150ms ease-in-out')),
      transition('zoomOut => zoomIn', animate('150ms ease-in-out'))
    ]),
    trigger('finishTimerCount', [
      state('zoomIn', style({
        transform: 'scale(1.1)'
      })),
      state('zoomOut', style({
        transform: 'scale(1)'
      })),
      transition('zoomIn => zoomOut', animate('150ms ease-in-out')),
      transition('zoomOut => zoomIn', animate('150ms ease-in-out'))
    ]),
    trigger('alertGame', [
      state('hide', style({
        opacity: '0',
        transform: 'translateY(-20px)',
      })),
      state('show', style({
        opacity: '1',
        transform: 'translateY(0)',
      })),
      transition('hide => show', animate('300ms ease-in')),
      transition('show => hide', animate('300ms ease-out'))
    ]),
    trigger('alertMoneyWin', [
      state('hide', style({
        opacity: '0',
        transform: 'translateY(20px)',
      })),
      state('show', style({
        opacity: '1',
        transform: 'translateY(0)',
      })),
      transition('hide => show', animate('300ms ease-in')),
      transition('show => hide', animate('300ms ease-out'))
    ]),
    trigger('alertMoneyRefund', [
      state('hide', style({
        opacity: '0',
        transform: 'translateY(20px)',
      })),
      state('show', style({
        opacity: '1',
        transform: 'translateY(0)',
      })),
      transition('hide => show', animate('300ms ease-in')),
      transition('show => hide', animate('300ms ease-out'))
    ])
  ]
})
export class XocdiaComponent implements OnInit, OnDestroy {
  @ViewChild('elListChat', {static: false}) elListChat: ElementRef;
  @ViewChild('elBoxChat', {static: false}) elBoxChat: ElementRef;
  @ViewChild('resultBottom', {static: false}) elResultBottom: ElementRef;
  @ViewChild(IonContent, {static: false}) content: IonContent;
  @ViewChild('plateCount', {static: false}) elPlateCount: ElementRef;
  @ViewChild('wrapGameXD', {static: false}) elWrapGameXD: ElementRef;
  @ViewChild('dice1') dice1: ElementRef;
  @ViewChild('dice2') dice2: ElementRef;
  @ViewChild('dice3') dice3: ElementRef;
  @ViewChild('dice4') dice4: ElementRef;

  valMoneyBetChan = 0;
  valMoneyBetLe = 0;
  timerCount = '00';
  isTimerCount = true;
  timeInterVal = null;
  countUserChan = 0;
  countUserLe = 0;
  moneyCountChan = 0;
  moneyCountLe = 0;
  isMoneyChan = true;
  isMoneyLe = true;
  moneyConfirmChan = 0;
  moneyConfirmLe = 0;
  showBoxChat = 'leave';
  showSuggestChat = 'leave';
  arrowToggleChat = 'down';
  effectMoneyChanBetting = 'zoomOut';
  effectMoneyLeBetting = 'zoomOut';
  effectFinishTimerCount = 'zoomOut';
  effectTimerCountdown = 'zoomOut';
  effectMoneyWin = 'hide';
  effectMoneyRefund = 'hide';
  isHotTimerCount = false;
  isDiceJump = false;
  isHasResult = false;
  posiDiceResult1 = -1;
  posiDiceResult2 = -1;
  posiDiceResult3 = -1;
  posiDiceResult4 = -1;
  isFinishTimerCount = false;
  finishTimerCount = '';
  isResultChan = false;
  isResultLe = false;

  timeoutEffectDiceJump = null;
  timeoutMoneyWin = null;
  timeoutMoneyRefund = null;

  moneyBetting = [
    {
      txt: '1K',
      val: 1000
    },
    {
      txt: '10K',
      val: 10000
    },
    {
      txt: '50K',
      val: 50000
    },
    {
      txt: '100K',
      val: 100000
    },
    {
      txt: '500K',
      val: 500000
    },
    {
      txt: '1M',
      val: 1000000
    },
    {
      txt: '5M',
      val: 5000000
    },
    {
      txt: '10M',
      val: 10000000
    }
  ];
  issue = '00000';
  paramsWSBet = {taixiuId: 0, userId: 0, loginname: '', betamount: 0, typed: 0, userType: 0, betfrom: 0}; // betfrom = 0 PC, betfrom = 1 Android, betfrom = 2 IOS, betfrom = 3 WAP
  userInfo = null;
  isTimerCountBetFinish = false;
  currMoneyChanBetting = 0;
  currMoneyLeBetting = 0;
  moneyWin = 0;
  moneyRefund = 0;
  subscription: Subscription[] = [];
  subscriptionOpenWin: Subscription;
  subscriptionCountdown: Subscription;
  subscriptionScreenOri: Subscription;
  subscriptionChat: Subscription;
  balance = 0;
  msg = '';
  timeOutValRandChat = null;
  listHisPhien = [];
  isPlateClose = true;
  isEffectPlaceClose = false;
  isLandscape = false;
  modalTKPhien = null;
  isMaintain = false;

  checkIsNextPhien = false;
  isOpenedWin = false;

  subscriptionBalance: Subscription;

  constructor(
    private modalCtr: ModalController,
    private wstxcbService: WstxcbService,
    public accountService: AccountService,
    private hpService: HelperService,
    private screenOrientation: ScreenOrientation,
    public platform: Platform,
    private apiService: ApiService,
    private translateConfigService: TranslateConfigService,
    private customNumber: CustomNumberService
  ) {
    this.wstxcbService.sendMessage(this.hpService.MINI_MSG_LSP_XD, {});
    this.wstxcbService.sendMessage(this.hpService.MINI_MSG_PUBLIC_XD, {});
    setTimeout(_ => {
      this.wstxcbService.sendMessage(this.hpService.MINI_MSG_LSP_XD, {});
      this.moneyConfirmChan = this.moneyConfirmLe = 0;
      this.currMoneyChanBetting = this.currMoneyLeBetting = 0;
    }, 2000);

    platform.ready().then((readySource) => {
      this.detectScreenOrient();
    });
    this.subscriptionScreenOri = screenOrientation.onChange().subscribe(
      () => {
        this.detectScreenOrient();
      }
    );
    this.subscription.push(this.subscriptionScreenOri);
  }

  detectScreenOrient() {
    setTimeout(() => {
      const pH = this.platform.height();
      const pW = this.platform.width();
      let hGame = 0;
      if (pW > pH) {
        this.isLandscape = true;
        hGame = 332;
      } else if (pW < pH) {
        this.isLandscape = false;
        hGame = 549;
      }

      if (pH < hGame) {
        this.elWrapGameXD.nativeElement.style.transform = `scale(${(pH / hGame)})`;
      } else {
        this.elWrapGameXD.nativeElement.style.transform = `scale(1)`;
      }
    }, 100);
  }

  collideCircle(circle1, circle2) {
    const distanceX = circle1.x - circle2.x;
    const distanceY = circle1.y - circle2.y;
    const radiiSum = circle1.radius + circle2.radius;
    return distanceX * distanceX + distanceY * distanceY <= radiiSum * radiiSum;
  }

  ngOnInit() {

    this.paramsWSBet.loginname = localStorage.getItem('ur');
    this.paramsWSBet.userType = 0;

    const getHisBet = this.wstxcbService.objHisBet;
    if (getHisBet && getHisBet.bt > 0) {
      this.moneyConfirmChan = getHisBet.bt;
      this.isMoneyChan = false;
    } else if (getHisBet && getHisBet.bx > 0) {
      this.moneyConfirmLe = getHisBet.bx;
      this.isMoneyLe = false;
    }

    //topic balance
    this.subscriptionBalance = this.hpService.getObserverBalance().subscribe(body => {
      this.balance = body.rs;
    });
    this.subscription.push(this.subscriptionBalance);

    // topic/xd => public
    this.subscriptionCountdown = this.hpService.getObserverGameXD().subscribe(body => {
      // START flag maintain
      if (body.cmd === 12 && body.rs) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-game-maintain')});
        this.isMaintain = true;
      }
      // END flag maintain

      // START countdown 50s
      if (body.cmd === 1) {
        if (body.cd == 50) {
          this.moneyConfirmChan = this.moneyConfirmLe = 0;
        }
        this.issue = this.paramsWSBet.taixiuId = body.id;
        this.countUserChan = body.ut;
        this.countUserLe = body.ux;
        this.moneyCountChan = body.at;
        if (this.currMoneyChanBetting < this.moneyCountChan) {
          this.currMoneyChanBetting = this.moneyCountChan;
          this.effectMoneyChanBetting = 'zoomIn';
          setTimeout(() => {
            this.effectMoneyChanBetting = 'zoomOut';
          }, 160);
        }
        this.moneyCountLe = body.ax;
        if (this.currMoneyLeBetting < this.moneyCountLe) {
          this.currMoneyLeBetting = this.moneyCountLe;
          this.effectMoneyLeBetting = 'zoomIn';
          setTimeout(() => {
            this.effectMoneyLeBetting = 'zoomOut';
          }, 160);
        }
        if (body.cd <= 10) {
          this.isHotTimerCount = true;
          this.effectTimerCountdown = 'zoomIn';
          setTimeout(() => {
            this.effectTimerCountdown = 'zoomOut';
          }, 160);
        } else {
          this.isHotTimerCount = false;
        }
        if (body.cd < 10) {
          this.timerCount = `0${body.cd}`;
        } else {
          this.timerCount = `${body.cd}`;
        }
        body.cd < 2 ? this.isTimerCountBetFinish = true : this.isTimerCountBetFinish = false;
        this.isResultChan = this.isDiceJump = this.isHasResult = this.isResultLe = this.isFinishTimerCount = false;
        this.isTimerCount = true;
        const elEffectDotResult = this.elResultBottom.nativeElement.querySelector('i');
        if (elEffectDotResult) {
          elEffectDotResult.remove();
        }

        this.isPlateClose = true;
        this.isOpenedWin = false;
      }
      // END countdown 50s

      // START chat responsive
      if (body.cmd === 10) {
        this.appendNewLineChat({u: body.u, msg: body.m.trim()});
      }
      // END chat responsive

      // START trả tiền cân chửa
      if (body.cmd === 1 && body.cd === 0) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-door-balance')});

        // START show money can bang
        body.at > body.ax ? this.moneyCountChan = this.moneyCountLe = body.ax : this.moneyCountLe = this.moneyCountChan = body.at;
        // END show money can bang

        this.effectMoneyChanBetting = this.effectMoneyLeBetting = 'zoomIn';
        setTimeout(() => {
          this.effectMoneyChanBetting = this.effectMoneyLeBetting = 'zoomOut';
        }, 160);
      }
      // END trả tiền cân chửa

      // START return result dice and effect dice jump
      if (body.cmd === 5 && body.cd === -1) {
        this.listHisPhien.unshift({id: body['id'], result: body['rs']});
        this.listHisPhien.pop();
        this.hpService.observableHisPhienXD.next(this.listHisPhien);
        this.effectDiceJump(body.rs);
      }
      // END return result dice and effect dice jump

      // START countdown finish issue
      if (body.cmd === 2 && body.cd <= 14) {
        this.isPlateClose = false;

        if (this.isMaintain && body.cd === 10) {
          this.isMaintain = false;
          this.closeGame();
          return;
        }

        // time wait for render dot and show effect dot
        setTimeout(() => {
          this.isFinishTimerCount = true;
        }, 200);

        this.initModalHasResult(body);

        if (body.cd < 10) {
          this.finishTimerCount = `0${body.cd}`;
        } else {
          this.finishTimerCount = `${body.cd}`;
        }
        this.effectFinishTimerCount = 'zoomIn';
        setTimeout(() => {
          this.effectFinishTimerCount = 'zoomOut';
        }, 160);
        if (body.cd === 0) {
          if (this.isPlateClose) {
            this.isOpenedWin = true;
            this.appendDotResult();
          }
          this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-start-new-turn')});
          this.moneyConfirmChan = this.moneyConfirmLe = 0;
          this.currMoneyChanBetting = this.currMoneyLeBetting = 0;
          this.wstxcbService.objHisBet = {bt: null, bx: null};
        }

        if (body.cd === 10) {
          this.hpService.observableIsValidNextTKPTXCB.next({flag: 'reloadTkP', issueNew: this.issue});
        }
      }
      this.checkIsNextPhien = false;
      if (body.cmd === 2 && body.cd <= 17) {
        this.checkIsNextPhien = true;
      }
      // END countdown finish issue

      // START check valid next tkPhien
      if (body.cmd === 1 || body.cmd === 2) {
        this.hpService.observableIsValidNextTKPTXCB.next('checkNextTKPhien');
      }
      // END check valid next tkPhien
    });
    this.subscription.push(this.subscriptionCountdown);

    // user/queue/xd => only user
    this.subscriptionOpenWin = this.wstxcbService.receiveMessageQueueXD().subscribe(wsData => {
      const body = JSON.parse(wsData.body);

      // START betting
      if (body.cmd === 3) {
        let error = false;
        let msg = '';
        let isLockedError = false;
        if (body.status === 0) {
          this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-success-bet')});
          this.getUserInfo();
          if (!this.isMoneyChan) {
            this.moneyConfirmChan += this.valMoneyBetChan;
            this.valMoneyBetChan = 0;
            this.wstxcbService.objHisBet = {bt: this.moneyConfirmChan, bx: 0};
          } else if (!this.isMoneyLe) {
            this.moneyConfirmLe += this.valMoneyBetLe;
            this.valMoneyBetLe = 0;
            this.wstxcbService.objHisBet = {bt: 0, bx: this.moneyConfirmLe};
          }
        } else if (body.status === 8) {
          if (this.valMoneyBetLe > 0 && !this.isMoneyLe) {
            msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-bet-tai');
          } else if (this.valMoneyBetChan > 0 && !this.isMoneyChan) {
            msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-bet-xiu');
          }
          error = true;
        } else if (body.status === 1 && !this.isTimerCount) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-turn-not-start');
        } else if (body.status === 1 && this.isTimerCount) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-time-out');
        } else if (body.status === 99) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-system-error');
        } else if (body.status === 13) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-money');
        } else if (body.status === 14) {
          error = true;
          msg = 'Nhằm đảm bảo sự an toàn của tài khoản，mời quý khách đăng nhập lại vào tài khoản sau đó đổi mật khẩu trước khi đặt cược!';
        } else if (body.status === 15) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-account-lock');
        } else if (body.status === 16) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-balance');
        } else if (body.status === 12) {
          error = true;
          isLockedError = true;
          msg = 'Bạn đã bị chặn cược trò chơi này, vui lòng liên hệ CSKH!';
        } else if (body.status === 10) {
          error = true;
          msg = this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-min-max-money');
        }

        if (error && msg !== '') {
          if (!isLockedError) {
            this.valMoneyBetChan = this.valMoneyBetLe = 0;
            this.hpService.observableAlertMiniGame.next({msg});
          } else {
            this.hpService.observableAlertMiniGame.next({msg, delayTime: 4500});
          }
        }
      }
      // END betting

      // START return money win if has betting
      if (body.cmd === 4 && body.amount > 0) {
        this.moneyWin = body.amount;
        this.getUserInfo();
      }
      // END return money win if has betting

      // START history phien
      if (body.cmd === 6) {
        this.listHisPhien = body.data.filter(item => item.result !== null && item.status === 0).map(item => {
          return {
            id: item['id'],
            // tslint:disable-next-line:no-eval
            result: eval(item['result'])
          };
        }).slice(0, 75);
        const listDotHisPhien: Array<any> = this.listHisPhien.filter((item, idx) => idx < 12).reverse();
        let htmlDotHisPhien = '';
        this.elResultBottom.nativeElement.innerHTML = '';
        listDotHisPhien.forEach((item, idx) => {
          let resultTotal = item['result'][0] + item['result'][1] + item['result'][2] + item['result'][3];
          let txtResult = this.translateConfigService.getTranslateService().instant('MINI-GAME.hoa-short');
          let clsDotResult = 'dotHoa';
          if (resultTotal == 4 || resultTotal == 0) {
            txtResult = this.translateConfigService.getTranslateService().instant('MINI-GAME.chan-short');
            clsDotResult = 'dotTai';
          } else if (resultTotal == 3 || resultTotal == 1) {
            txtResult = this.translateConfigService.getTranslateService().instant('MINI-GAME.le-short');
            clsDotResult = 'dotXiu';
          }
          const el = `<span class="dotResult ${clsDotResult}">${txtResult}</span>`;
          htmlDotHisPhien += el;
        });
        this.elResultBottom.nativeElement.innerHTML = htmlDotHisPhien;
      }
      // END history phien

      // START refund money
      if (body.cmd === 7 && body.amount > 0) {
        this.moneyRefund = body.amount;
        this.effectMoneyRefund = 'show';
        this.getUserInfo();
        this.timeoutMoneyRefund = setTimeout(() => {
          this.effectMoneyRefund = 'hide';
          setTimeout(() => {
            this.moneyRefund = 0;
          }, 110);
        }, 2000);
      }
      // END refund money

      // START get total bet
      if (body.cmd === 13) {
        const moneyBet = Number(body.rs.split(':')[0]);
        const getTyped = body.rs.split(':')[1];
        getTyped === '1' ? this.moneyConfirmChan = moneyBet : this.moneyConfirmLe = moneyBet;
      }
      // END get total bet

      // START chat list history
      if (body.cmd === 11) {
        const arrChatHis = [];
        body.data.forEach(item => {
          arrChatHis.push({u: item.u, msg: item.m.trim(), status: 1});
        });
        const arrChat = arrChatHis;

        let htmlChat = '';
        arrChat.forEach(item => {
          htmlChat += `<div class="txtChat"><span>${item.u}:</span>${item.msg}</div>`;
        });
        this.elListChat.nativeElement.innerHTML = htmlChat;
        setTimeout(() => {
          this.content.scrollToBottom().then(r => {
          });
        });
      }
      // END chat list history

      // START block chat user
      if (body.cmd === 10) {
        if (body.rs) {
          this.appendNewLineChat({u: '', msg: body.rs, status: 0});
        }
      }
      // END block chat user
    });
    this.subscription.push(this.subscriptionOpenWin);

    ///topic/xocdia
    this.subscriptionChat = this.wstxcbService.receiveMessageChatXD().subscribe(wsData => {
      const body = JSON.parse(wsData.body);
      if (body.cmd === 10) {
        this.appendNewLineChat({u: body.u, msg: body.m.trim()});
      }
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.timeInterVal);
    clearTimeout(this.timeoutMoneyWin);
    clearTimeout(this.timeoutMoneyRefund);
    this.subscription.forEach(subscription => {
      if (subscription !== null) {
        subscription.unsubscribe();
      }
    });
    clearTimeout(this.timeOutValRandChat);
    //  this.hpService.observableAlertTXCB.next({msg: 'closeGame'});
  }

  ionViewWillEnter() {
    this.getUserInfo();
  }

  appendNewLineChat(item: { u: string, msg: string, status?: number }) {
    // START remove el txt chat first
    const elTxtChatFirst = this.elListChat.nativeElement.querySelectorAll('.txtChat');
    if (elTxtChatFirst && elTxtChatFirst.length > 0) {
      this.elListChat.nativeElement.querySelectorAll('.txtChat')[0].remove();
    }
    // END remove el txt chat first

    // START add element txt chat
    const elTxtChat = document.createElement('div');
    elTxtChat.classList.add('txtChat');
    if (item.status === 0) {
      elTxtChat.classList.add('errorChat');
    }
    elTxtChat.innerHTML = `<span>${item.u}:</span>${item.msg}`;
    this.elListChat.nativeElement.appendChild(elTxtChat);
    // END add element txt chat

    this.content.scrollToBottom(250).then(r => {
    });
  }

  initModalHasResult(body) {
    if (body.rs) {
      this.issue = this.paramsWSBet.taixiuId = body.id;
      this.isTimerCount = false;
      this.isHasResult = this.isDiceJump = true;
      this.posiDiceResult1 = body.rs[0];
      this.posiDiceResult2 = body.rs[1];
      this.posiDiceResult3 = body.rs[2];
      this.posiDiceResult4 = body.rs[3];
      this.countUserChan = body.ut;
      this.countUserLe = body.ux;

      this.effectResultTxt();

      // START show money can bang
      body.at > body.ax ? this.moneyCountChan = this.moneyCountLe = body.ax : this.moneyCountLe = this.moneyCountChan = body.at;
      // END show money can bang
    }
  }

  ionViewDidEnter() {
    this.showBoxChat = 'show';
  }

  toggleInputMoney(event, flag) {
    event.preventDefault();
    setTimeout(() => {
      this.valMoneyBetLe = this.valMoneyBetChan = 0;
      if (flag === 'chan') {
        this.isMoneyChan = false;
        this.isMoneyLe = true;
      } else if (flag === 'le') {
        this.isMoneyLe = false;
        this.isMoneyChan = true;
      }
    }, 100);
  }

  async closeGame() {
    await this.modalCtr.dismiss();
  }

  effectDiceJump(arrayDice) {
    this.setResultPosition();
    this.isDiceJump = true;
    this.isTimerCount = false;
    this.isEffectPlaceClose = true;

    // timeout dice effect
    this.timeoutEffectDiceJump = setTimeout(() => {
      this.isEffectPlaceClose = false;
      this.isDiceJump = false;
      this.isHasResult = true;

      // START show result Dices
      this.posiDiceResult1 = arrayDice[0];
      this.posiDiceResult2 = arrayDice[1];
      this.posiDiceResult3 = arrayDice[2];
      this.posiDiceResult4 = arrayDice[3];
      // END show result Dices

      this.isPlateClose = false;
      this.openWin();

    }, 3000);
  }

  setResultPosition() {
    const elDice1 = this.dice1.nativeElement;
    const elDice2 = this.dice2.nativeElement;
    const elDice3 = this.dice3.nativeElement;
    const elDice4 = this.dice4.nativeElement;

    elDice1.style.transform = `translate3d(${this.hpService.randomInteger(-10, 15)}px, ${this.hpService.randomInteger(-20, 15)}px, 0px) scale(0.4)`;
    elDice2.style.transform = `translate3d(${this.hpService.randomInteger(-10, 15)}px, ${this.hpService.randomInteger(-20, 15)}px, 0px) scale(0.4)`;
    elDice3.style.transform = `translate3d(${this.hpService.randomInteger(-10, 15)}px, ${this.hpService.randomInteger(-20, 15)}px, 0px) scale(0.4)`;
    elDice4.style.transform = `translate3d(${this.hpService.randomInteger(-10, 15)}px, ${this.hpService.randomInteger(-20, 15)}px, 0px) scale(0.4)`;
  }

  openWin() {
    this.effectResultTxt();
    this.effectMoneyWinUser();
    this.appendDotResult();

    this.hpService.observableReloadHisBetXD.next('reloadHisBet');

    this.getUserInfo();
  }

  effectMoneyWinUser() {
    if (this.moneyWin > 0) {
      this.effectMoneyWin = 'show';
      this.timeoutMoneyWin = setTimeout(() => {
        this.effectMoneyWin = 'hide';
        setTimeout(() => {
          this.moneyWin = 0;
        }, 310);
      }, 5000);
    }
  }

  effectResultTxt() {
    let resultTotal = this.posiDiceResult1 + this.posiDiceResult2 + this.posiDiceResult3 + this.posiDiceResult4;

    if (resultTotal == 4 || resultTotal == 0) {
      this.isResultChan = true;
      this.isResultLe = false;
    } else if (resultTotal == 3 || resultTotal == 1) {
      this.isResultChan = false;
      this.isResultLe = true;
    } else {
      this.isResultChan = true;
      this.isResultLe = true;
    }
  }

  appendDotResult() {
    const elDotResultFirst = this.elResultBottom.nativeElement.querySelectorAll('.dotResult');
    if (elDotResultFirst && elDotResultFirst.length > 0) {
      this.elResultBottom.nativeElement.querySelectorAll('.dotResult')[0].remove();
    }
    let resultTotal = this.posiDiceResult1 + this.posiDiceResult2 + this.posiDiceResult3 + this.posiDiceResult4;
    let txtResult = this.translateConfigService.getTranslateService().instant('MINI-GAME.hoa-short');
    let clsDotResult = 'dotHoa';
    if (resultTotal == 4 || resultTotal == 0) {
      txtResult = this.translateConfigService.getTranslateService().instant('MINI-GAME.chan-short');
      clsDotResult = 'dotTai';
    } else if (resultTotal == 3 || resultTotal == 1) {
      txtResult = this.translateConfigService.getTranslateService().instant('MINI-GAME.le-short');
      clsDotResult = 'dotXiu';
    }

    const elDotResultNew = document.createElement('span');
    if (this.isPlateClose) {
      elDotResultNew.innerHTML = `{{txtResult}}`;
    } else {
      elDotResultNew.innerHTML = `<i></i>${txtResult}`;
    }
    elDotResultNew.classList.add('dotResult', `${clsDotResult}`);
    this.elResultBottom.nativeElement.appendChild(elDotResultNew);
  }

  selectMoneyBetting(event, item) {
    event.preventDefault();
    if (!this.isMoneyLe) {
      this.valMoneyBetLe += item.val;
    } else if (!this.isMoneyChan) {
      this.valMoneyBetChan += item.val;
    } else {
      this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-choose-tx')});
    }
  }

  cancelBetting(event) {
    event.preventDefault();
    this.valMoneyBetChan = this.valMoneyBetLe = 0;
    this.isMoneyChan = this.isMoneyLe = true;
  }

  preventBetClick = false;

  betting(event) {
    event.preventDefault();
    if (!this.preventBetClick) {
      this.preventBetClick = true;
      setTimeout(() => {
        this.preventBetClick = false;
      }, 200);
      if (this.checkIsNextPhien) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-turn-not-start')});
        return;
      }
      if (this.isMoneyChan && this.isMoneyLe) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-choose-tx')});
        return;
      } else if (this.valMoneyBetChan === 0 && this.valMoneyBetLe === 0) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-please-bet-money')});
        return;
      }
      if (this.valMoneyBetChan > 0) {
        this.paramsWSBet.typed = 1;
        this.paramsWSBet.betamount = this.valMoneyBetChan;
      } else if (this.valMoneyBetLe > 0) {
        this.paramsWSBet.typed = 2;
        this.paramsWSBet.betamount = this.valMoneyBetLe;
      }
      // if (this.hpService.isMobileWebAndroid || this.hpService.isMobileWebIOS) {
      //     this.paramsWSBet.betfrom = 3;
      // } else if (this.hpService.isDeviceAndroid) {
      //     this.paramsWSBet.betfrom = 1;
      // } else if (this.hpService.isDeviceIOS) {
      //     this.paramsWSBet.betfrom = 2;
      // }

      if (this.paramsWSBet.betamount === null || this.paramsWSBet.betamount <= 0) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-money')});
        return;
      }
      if (this.paramsWSBet.betamount > this.balance) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-balance')});
        return;
      }
      if (this.paramsWSBet.betamount < 1000) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-min-money')});
        return;
      }
      if (this.paramsWSBet.betamount % 1000 !== 0) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-round-money')});
        return;
      }
      this.wstxcbService.sendMessage(this.hpService.MINI_MSG_BET_XD, this.paramsWSBet);
    }
  }

  allInBetting(event) {
    event.preventDefault();
    if (!this.preventBetClick) {
      this.preventBetClick = true;
      setTimeout(() => {
        this.preventBetClick = false;
      }, 200);
      if (this.isMoneyChan && this.isMoneyLe) {
        this.hpService.observableAlertMiniGame.next({msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-choose-tx')});
        return;
      }
      this.valMoneyBetLe = this.valMoneyBetChan = 0;
      if (this.valMoneyBetLe >= this.balance || this.valMoneyBetChan >= this.balance) {
        return;
      }
      if (!this.isMoneyLe) {
        this.valMoneyBetLe += Math.floor(this.balance / 1000) * 1000;
      } else if (!this.isMoneyChan) {
        this.valMoneyBetChan += Math.floor(this.balance / 1000) * 1000;
      }
    }
  }

  toggleBoxChat(event) {
    event.preventDefault();
    if (this.showBoxChat === 'hidden') {
      this.showBoxChat = 'leave';
      setTimeout(() => {
        this.wstxcbService.sendMessage(this.hpService.MINI_MSG_PUBLIC_XD, {});
        this.showBoxChat = 'show';
      }, 210);
    } else if (this.showBoxChat === 'show') {
      this.showBoxChat = 'leave';
      setTimeout(() => {
        this.showBoxChat = 'hidden';
      }, 410);
    }
  }

  bxhXD(event) {
    event.preventDefault();

    this.hpService.observableLoading.next(true);
    this.apiService.getRankXD().subscribe(
      data => {
        this.modalBXHXD(data).then(() => {
          this.hpService.observableLoading.next(false);
        });
      },
      error => {
        console.log(error);
        this.hpService.observableLoading.next(false);
      },
      () => {
      }
    );
  }

  async modalBXHXD(data) {
    const modal = await this.modalCtr.create({
      component: BxhXocDiaComponent,
      // enterAnimation: enterModalAnimation,
      // leaveAnimation: leaveModalAnimation,
      cssClass: 'modalTXCBBet',
      mode: 'md',
      componentProps: {
        dataBxh: data
      }
    });
    return await modal.present();
  }

  hdXD(event) {
    event.preventDefault();
    this.modalHDXD().then(() => {
      this.hpService.observableLoading.next(false);
    });
  }

  async modalHDXD() {
    const modal = await this.modalCtr.create({
      component: HdXocDiaComponent,
      cssClass: 'modalTXCBBet',
      mode: 'md',
    });
    return await modal.present();
  }

  hisBet(event) {
    event.preventDefault();

    this.hpService.observableLoading.next(true);
    this.apiService.getHisBetXD(0).subscribe(
      (data: HttpResponse<any>) => {
        this.modalLSCXD(data).then(() => {
          this.hpService.observableLoading.next(false);
        });
      },
      error => {
        console.log(error);
        this.hpService.observableLoading.next(false);
      },
      () => {
      }
    );
  }

  async modalLSCXD(data) {
    const modal = await this.modalCtr.create({
      component: LscXocDiaComponent,
      cssClass: 'modalTXCBBet',
      mode: 'md',
      componentProps: {
        dataHis: data
      }
    });
    return await modal.present();
  }

  hisPhien(event) {
    event.preventDefault();
    this.modalLSPXD().then(() => {
      this.hpService.observableHisPhienXD.next(this.listHisPhien);
    });
  }

  async modalLSPXD() {
    const modal = await this.modalCtr.create({
      component: LspXocDiaComponent,
      // enterAnimation: enterModalAnimation,
      // leaveAnimation: leaveModalAnimation,
      cssClass: 'modalTXCBBet',
      mode: 'md'
    });
    return await modal.present();
  }

  tkPhien(event) {
    event.preventDefault();
    let xdID = 0;
    if (Number(this.timerCount) > 0) {
      xdID = Number(this.issue) - 1;
    } else {
      xdID = Number(this.issue);
    }

    this.hpService.observableLoading.next(true);
    this.apiService.thongKePhienXD(xdID).subscribe(
      data => {
        this.modalTKPXD(data, xdID).then(() => {
          this.hpService.observableLoading.next(false);
        });
      },
      error => {
        console.log(error);
        this.hpService.observableLoading.next(false);
      },
      () => {
      }
    );
  }

  async modalTKPXD(data, prevIssue) {
    this.modalTKPhien = await this.modalCtr.create({
      component: TkpXocDiaComponent,
      // enterAnimation: enterModalAnimation,
      // leaveAnimation: leaveModalAnimation,
      cssClass: 'modalTXCBBet',
      mode: 'md',
      componentProps: {
        dataTKP: data,
        txID: prevIssue
      }
    });
    return await this.modalTKPhien.present();
  }

  sendChat(event) {
    event.preventDefault();
    /* if (this.balance < 20000) {
       this.appendNewLineChat({u: '', msg: 'Số dư của bạn phải trên 20,000 để có thể chat!', status: 0});
     } else*/
    if (this.msg !== '' && this.msg.length <= 120) {
      this.wstxcbService.sendMessage(this.hpService.MINI_MSG_CHAT_XD, {u: this.userInfo.login, m: this.msg});
    } else {
      this.appendNewLineChat({
        u: '',
        msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-invalid-message'),
        status: 0
      });
    }
    this.msg = '';
  }

  getUserInfo() {
    this.apiService.getUserInfoData({}).subscribe(
      res => {
        if (res.status === this.hpService.ERROR_CODE_SUCCESS) {
          this.balance = this.customNumber.balanceNum(res.data.balance);
          this.userInfo = {
            id: res.data.id,
            login: res.data.login,
            balance: res.data.balance
          };
        } else {
          this.hpService.handleError(res.message);
        }
      });

  }

}
